import { useHandleShortcutClick } from '@/hooks/useHandleShortcutClick';
import { useShortcuts } from '@/hooks/useShortcuts';

export const Shortcuts = () => {
  const shortcuts = useShortcuts();
  const handleShortcutClick = useHandleShortcutClick();

  if (shortcuts.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-3 w-full px-4 mt-16 mb-8">
      {shortcuts.map((shortcut) => {
        const Icon = shortcut.icon;
        return (
          <button
            key={shortcut.id}
            type="button"
            className="flex w-full items-center gap-3 rounded-md bg-card px-2 py-1.5 text-sm leading-5 font-normal text-popover-foreground hover:bg-accent"
            onClick={() => handleShortcutClick(shortcut)}
          >
            <Icon className="size-4 shrink-0 text-brand" />
            <span className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-left">
              {shortcut.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};
